// extracted by mini-css-extract-plugin
export default {"wrapper":"Fixed_wrapper__vHnDV","bottomRow":"Fixed_bottomRow__vhx8r","expandPanel":"Fixed_expandPanel__Tyhyp","expandPanelMobileOnly":"Fixed_expandPanelMobileOnly__fQq5G"};